/**
 * Null/undefined-safe locale comparison for sorting by string fields.
 *
 * Scheduling objects (agendas, operating rooms, surgeons, departments) can have
 * a null/undefined `name` in production data. Calling `null.localeCompare(...)`
 * throws and crashes the whole surgery scheduling page with "Something went
 * wrong" (SHER-466). Treat missing values as empty strings so they sort first
 * instead of breaking the comparator.
 */
export function safeLocaleCompare(a?: string | null, b?: string | null): number {
    return (a ?? '').localeCompare(b ?? '');
}
